export const CATEGORY_LABELS = {
  alkali_metals: "Alkali Metals",
  alkaline_earth: "Alkaline Earth",
  transition_metals: "Transition Metals",
  post_transition: "Post-Transition",
  metalloids: "Metalloids",
  reactive_nonmetals: "Reactive Non-metals",
  noble_gases: "Noble Gases",
  lanthanides: "Lanthanides",
  actinides: "Actinides",
  superheavy_synthetic: "Superheavy Synthetic",
};

export const CATEGORY_BG = {
  alkali_metals: "bg-red-500 text-black",
  alkaline_earth: "bg-orange-500 text-black",
  transition_metals: "bg-yellow-400 text-black",
  post_transition: "bg-lime-400 text-black",
  metalloids: "bg-emerald-400 text-black",
  reactive_nonmetals: "bg-cyan-400 text-black",
  noble_gases: "bg-zinc-200 text-black",
  lanthanides: "bg-blue-400 text-black",
  actinides: "bg-indigo-400 text-white",
  superheavy_synthetic: "bg-zinc-950 text-white",
};

export const HAZARD_LABELS = {
  extreme: "EXTREME",
  high: "HIGH",
  warning: "WARNING",
  safe: "LOW",
  unknown: "UNKNOWN",
};

export const HAZARD_BG = {
  extreme: "bg-[#FF003C] text-white",
  high: "bg-[#FF8A00] text-black",
  warning: "bg-[#FFD700] text-black",
  safe: "bg-[#00E5FF] text-black",
  unknown: "bg-zinc-300 text-black",
};
